import * as types from './admission.types'

export const actions = {
  toggleLoading: payload => ({
    type: types.TOGGLE_LOADING,
    payload,
  }),
  toggleSuccess: payload => ({
    type: types.TOGGLE_SUCCESS,
    payload,
  }),
  create: payload => ({
    type: types.CREATE_ADMISSION,
    payload,
  }),
  get: payload => ({
    type: types.GET_ADMISSION,
    payload,
  }),
  set: payload => ({
    type: types.SET_ADMISSION,
    payload,
  }),
  edit: payload => ({
    type: types.EDIT_ADMISSION,
    payload,
  }),
  delete: payload => ({
    type: types.DELETE_ADMISSION,
    payload,
  }),
  getOptions: payload => ({
    type: types.GET_OPTIONS,
    payload,
  }),
  setOptions: payload => ({
    type: types.SET_OPTIONS,
    payload,
  }),
  setPermissions: payload => ({
    type: types.SET_PERMISSIONS,
    payload,
  }),
  clearPermissions: payload => ({
    type: types.CLEAR_PERMISSIONS,
    payload,
  }),
}
